












import { computed, defineComponent } from '@vue/composition-api';
import VehicleAccordion from '@/components/Comparison/VehicleAccordion.vue';
import VehicleEmptyRow from '@/components/Comparison/VehicleEmptyRow.vue';
import VehiclePropRow from '@/components/Comparison/VehiclePropRow.vue';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import DealerLogoRow from '@/components/Comparison/DealerLogoRow.vue';
import SellerReviewsRow from '@/components/Comparison/SellerReviewsRow.vue';
import DealerAddressRow from '@/components/Comparison/DealerAddressRow.vue';
import DealerContactsRow from '@/components/Comparison/DealerContactsRow.vue';
import DealerEnquiriesRow from '@/components/Comparison/DealerEnquiriesRow.vue';

export default defineComponent({
    name: 'SellerSection',
    components: {
        DealerAddressRow,
        SellerReviewsRow,
        DealerLogoRow,
        VehicleAccordion,
        VehiclePropRow,
        VehicleEmptyRow,
        DealerEnquiriesRow,
        DealerContactsRow
    },
    setup () {
        const store = useStore();
        const isOpened = computed(() => store.state.menuSellerOpened);
        const toggleAccordion = () => {
            store.dispatch(ActionTypes.SetIsMenuSellerOpened, !isOpened.value);
        };
        const townes = computed(() => store.getters.visibleValuesOf(store.state.townes));

        return {
            isOpened,
            toggleAccordion,
            townes
        };
    }
});
